import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=2d158120&scoped=true"
import script from "./operate.vue?vue&type=script&lang=js"
export * from "./operate.vue?vue&type=script&lang=js"
import style0 from "./operate.vue?vue&type=style&index=0&id=2d158120&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d158120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d158120')) {
      api.createRecord('2d158120', component.options)
    } else {
      api.reload('2d158120', component.options)
    }
    module.hot.accept("./operate.vue?vue&type=template&id=2d158120&scoped=true", function () {
      api.rerender('2d158120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/integral/pointsActivity/operate.vue"
export default component.exports